import { WEEKDAYS, MAX_MONTHS, MONTH, STATE_MONTHS } from '@app/src/common/datePicker/state/calendar/constants';
import { DayType } from '@app/src/common/datePicker/types/Day';
import { DateType } from '@app/src/common/datePicker/types/Date';

export const getPrevDate = ({ month, year }: DateType): DateType => {
  if(month > MONTH.FIRST) {
    return {
      month: month - 1,
      year
    }
  }
  return {
    month: MONTH.LAST,
    year: year - 1
  }
};

export const getNextDate = ({ month, year }: DateType): DateType => {
  if(month < MONTH.LAST) {
    return {
      month: month + 1,
      year
    };
  }
  return {
    month: MONTH.FIRST,
    year: year + 1
  };
};


const getTotalDays = (month: number, year: number): number => {
  return 32 - new Date(year, month, 32).getDate();
};

const getFirstDay = (month: number, year: number): number => {
  const firstDay: number = new Date(year, month).getDay() - 1;
  return firstDay < 0 ? 6 : firstDay;
};

const getLastDay = (month: number, year: number): number => {
  const firstDay: number = new Date(year, month + 1, 0).getDay() - 1;
  return firstDay < 0 ? 6 : firstDay;
};

export const getCalendar = (printData) => {
  const { id } = printData;
  const calendar = [];
  let month = new Date().getMonth();
  let year = new Date().getFullYear();
  for(let i = 1; i <= MAX_MONTHS; i++) {
    if (month % 12 === 0 && month > 1) {
      year++;
    }
    calendar.push(getDaysByMonth(month, year, i-1));
    month++;
  }
  return getValidateDateByPrint[id](calendar, printData);
};

const validPosition = (currentMonth: number) => (currentMonth % 12);

const getDaysByMonth = (currentMonth: number, year: number, positionMonth: number): DayType[] => {
  const monthValid = validPosition(currentMonth);
  const daysMonth = [];
  let initialDay: number = 1;
  const rowsByMonth: number = 6;
  const weekDays: number = 6;
  const firstDay: number = getFirstDay(monthValid, year);
  let dayNextMonth = 1;

  const refMonthPrev = monthValid === 0 ? 11 : monthValid - 1;
  const refYearPrev = monthValid === 0 ? year - 1 : year;
  const refMonthNext = monthValid === 11 ? 0 : monthValid + 1;
  const refYearNext = monthValid === 11 ? year + 1 : year;
  const lastDay: any = new Date(refYearPrev, refMonthPrev + 1, 0).getDate();
  let lastDayPosition: number = getLastDay(refMonthPrev, refYearPrev);
  let dayPrev = lastDay - lastDayPosition;

  for(let i = 0; i < rowsByMonth; i++) {
    for(let j = 0; j <= weekDays; j++) {
      if(i === 0 && j < firstDay) {
        daysMonth.push({
          id: `${dayPrev}${refMonthPrev}${refYearPrev}${positionMonth - 1}`,
          stateMonth: STATE_MONTHS.PREV,
          dayMonth: dayPrev,
          dayName: WEEKDAYS[j],
          disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.PREV, positionMonth, dayPrev),
          dayWeekPos: j,
          otherDayMonth: true,
          month: refMonthPrev,
          year: refYearPrev
        });
        dayPrev++;
        continue;
      }
      if (initialDay > getTotalDays(currentMonth, year)) {
        const daysNext = dayNextMonth++;
        daysMonth.push({
          id: `${daysNext}${refMonthNext}${refYearNext}${positionMonth +1}`,
          stateMonth: STATE_MONTHS.NEXT,
          dayMonth: daysNext,
          dayName: WEEKDAYS[j],
          disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.NEXT, positionMonth, daysNext),
          dayWeekPos: j,
          otherDayMonth: true,
          month: refMonthNext,
          year: refYearNext
        });
        continue;
      }
      daysMonth.push({
        id: `${initialDay}${monthValid}${year}${positionMonth}`,
        dayMonth: initialDay,
        stateMonth: STATE_MONTHS.CURRENT,
        dayName: WEEKDAYS[j],
        disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.CURRENT, positionMonth, initialDay),
        dayWeekPos: j,
        otherDayMonth: false,
        month: monthValid,
        year
      });
      initialDay++;
    }
  }
  return daysMonth;
};

const setDisabledDaysByBehaviorCalendar = (stateMonth: string, posMonth: number, dayMonth: number) => {
  const currentDay = new Date().getDate();
  if (posMonth === 0) {
    if (dayMonth < currentDay && stateMonth === STATE_MONTHS.CURRENT) {
      return true;
    }
    if (stateMonth === STATE_MONTHS.PREV) {
      return true;
    }
  }
  if (posMonth === MAX_MONTHS - 1 && stateMonth === STATE_MONTHS.NEXT) {
      return true;
  }
  return false;
};

const isToday = (day: DayType) => {
  const currentDay = new Date().getDate();
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  return day.dayMonth === currentDay && day.month === currentMonth && day.year === currentYear;
};

const validateDatePublicationTimeTalanD = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let nextSundayPosition = 0;
        for (let i = currentDayPosition; i < 6; i++) {
          nextSundayPosition++;
        }
        const positionResult = j + nextSundayPosition;
        if (
          !calendar[i][positionResult].disabled &&
          calendar[i][j].dayWeekPos <= closeDay
        ) {
          if (calendar[i][j].dayWeekPos === closeDay && currentHour >= closeHour) {
            calendar[i][positionResult].disabled = true;
          } else {
            calendar[i][positionResult].disabled = false;
            }
        } else {
          calendar[i][positionResult].disabled = true;
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeComercioMS = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      } 

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let restForIndexDayAround = -(currentDayPosition);

        for(let c=0; c<allowDay.length; c++) {
          const dayCalendar = calendar[i][j + restForIndexDayAround];
          restForIndexDayAround++;
          if (currentDayPosition < allowDay[c]) {
            let indexCloseDay = closeDay.indexOf(currentDayPosition);
            if (currentDayPosition === 4) {
              indexCloseDay = 5;
            } 
            const currentCloseHour = closeHour[indexCloseDay];
            const currentAllowDay = allowDay[indexCloseDay];

            if (indexCloseDay > 0) {
              if (currentAllowDay > currentDayPosition && indexCloseDay === c) {
                if (currentHour >= currentCloseHour) {
                  if (dayCalendar && !dayCalendar.disabled) {
                    dayCalendar.disabled = true;
                  }
                }
              }
            }
          } else {
            if (dayCalendar && !dayCalendar.disabled) {
              dayCalendar.disabled = true;
            }
            if ( currentDayPosition === 4 ) {
              const currentCloseHour = closeHour[0];
              if (currentHour >= currentCloseHour) {
                if (!calendar[i][j + 3].disabled) {
                  calendar[i][j + 3].disabled = true;
                }
              } 
            }
            if ( currentDayPosition === 5 ) {
              if (!calendar[i][j + 2].disabled) {
                calendar[i][j + 2].disabled = true;
              }
            }
            if ( currentDayPosition === 6 ) {
              if (!calendar[i][j + 1].disabled) {
                calendar[i][j + 1].disabled = true;
              }
            }
          }
        }
      }
    }
  }
  return calendar;
};

const validateDatePublicationTimeComercioD = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let nextSundayPosition = 0;
        for (let i = currentDayPosition; i < 6; i++) {
          nextSundayPosition++;
        }
        const positionResult = j + nextSundayPosition;
        if (
          !calendar[i][positionResult].disabled &&
          calendar[i][j].dayWeekPos <= closeDay
        ) {
          if (calendar[i][j].dayWeekPos === closeDay && currentHour >= closeHour) {
            calendar[i][positionResult].disabled = true;
          } else {
            calendar[i][positionResult].disabled = false;
          }
        } else {
          calendar[i][positionResult].disabled = true;
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeTalanS = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let nextSaturdayPosition = 0;
        for (let i = currentDayPosition; i < 5; i++) {
          nextSaturdayPosition++;
        }
        const positionResult = j + nextSaturdayPosition;
        if (currentDayPosition >= closeDay) {
          if(!calendar[i][positionResult].disabled) {
            if (currentDayPosition === closeDay) {
              if (currentHour >= closeHour) {
                calendar[i][positionResult].disabled = true;
              } else {
                calendar[i][positionResult].disabled = false;
              }
            } else {
              calendar[i][positionResult].disabled = true;
            }
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeTalanLV = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
        if (isToday(calendar[i][j]) && calendar[i][j].dayWeekPos === currentDayPosition) {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let restForIndexDayAround = -(currentDayPosition);

        for(let c=0; c<allowDay.length; c++) {
          const dayCalendar = calendar[i][j + restForIndexDayAround];
          restForIndexDayAround++;

          if(c === 0 || c === 1) {
            dayCalendar.disabled = true;
          }
          
          const indexCloseDay = closeDay.indexOf(currentDayPosition);
          if (indexCloseDay >= 0) {
            const currentCloseHour = closeHour[indexCloseDay];
            if (allowDay[c] > closeDay[c]) {
              if (c < indexCloseDay) {
                if (dayCalendar && !dayCalendar.disabled) {
                  dayCalendar.disabled = true;
                } 
              }
              if (c === indexCloseDay) {
                if (currentHour >= currentCloseHour) {
                  if (dayCalendar && !dayCalendar.disabled) {
                    dayCalendar.disabled = true;
                  }
                } 
              }
            }
            if ( currentDayPosition === 4 ) {
              if (currentHour >= currentCloseHour) {
                if (!calendar[i][j + 3].disabled) {
                  calendar[i][j + 3].disabled = true;
                }
              } 
            }
            if ( currentDayPosition === 6 ) {
              if (!calendar[i][j + 1].disabled) {
                calendar[i][j + 1].disabled = true;
              }
              if (currentHour >= currentCloseHour) {
                if (!calendar[i][j + 2].disabled) {
                  calendar[i][j + 2].disabled = true;
                }
              } 
            }
          } else {
            if ( currentDayPosition === 5 ) {
              if (!calendar[i][j + 2].disabled) {
                calendar[i][j + 2].disabled = true;
              }
            }
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeDeporSD = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT) &&
        closeDay.includes(currentDayPosition)
      ) {
        let count = closeDay.indexOf(currentDayPosition);
        let ac = 0;
        for(let c=count; c >=0; c--) {
          const currentCloseHour = closeHour[c];
          if (closeDay[c] <= currentDayPosition) {
            const currentDay = calendar[i][j + 2 + ac];
            if (closeDay[c] === currentDayPosition) {
              if (!currentDay.disabled && currentHour >= currentCloseHour) {
                currentDay.disabled = true;
              }
            } else {
              if (!currentDay.disabled) {
                currentDay.disabled = true;
              }
            }
            ac--;
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeDeporLV = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
        if (isToday(calendar[i][j]) && calendar[i][j].dayWeekPos === currentDayPosition) {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j]) &&
        (calendar[i][j].stateMonth !== STATE_MONTHS.NEXT)
      ) {
        let restForIndexDayAround = -(currentDayPosition);

        for(let c=0; c<allowDay.length; c++) {
          const dayCalendar = calendar[i][j + restForIndexDayAround];
          restForIndexDayAround++;

          if(c === 0 || c === 1) {
            dayCalendar.disabled = true;
          }
          
          const indexCloseDay = closeDay.indexOf(currentDayPosition);
          if (indexCloseDay >= 0) {
            const currentCloseHour = closeHour[indexCloseDay];
            if (allowDay[c] > closeDay[c]) {
              if (c < indexCloseDay) {
                if (dayCalendar && !dayCalendar.disabled) {
                  dayCalendar.disabled = true;
                } 
              }
              if (c === indexCloseDay) {
                if (currentHour >= currentCloseHour) {
                  if (dayCalendar && !dayCalendar.disabled) {
                    dayCalendar.disabled = true;
                  }
                } 
              }
            }
            if ( currentDayPosition === 4 ) {
              if (currentHour >= currentCloseHour) {
                if (!calendar[i][j + 3].disabled) {
                  calendar[i][j + 3].disabled = true;
                }
              } 
            }
            if ( currentDayPosition === 6 ) {
              if (!calendar[i][j + 1].disabled) {
                calendar[i][j + 1].disabled = true;
              }
              if (currentHour >= currentCloseHour) {
                if (!calendar[i][j + 2].disabled) {
                  calendar[i][j + 2].disabled = true;
                }
              } 
            }
          } else {
            if ( currentDayPosition === 5 ) {
              if (!calendar[i][j + 2].disabled) {
                calendar[i][j + 2].disabled = true;
              }
            }
          }
        }
      }
    }
  }

  return calendar;
};

export const getValidateDateByPrint = {
  1: validateDatePublicationTimeComercioD,
  2: validateDatePublicationTimeTalanD,
  3: validateDatePublicationTimeComercioMS,
  4: validateDatePublicationTimeTalanS,
  5: validateDatePublicationTimeTalanLV,
  6: validateDatePublicationTimeDeporSD,
  7: validateDatePublicationTimeDeporLV
};

